export const HandbookIcon = ({ color = "#784EFF" }: { color?: string }) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="Book" clipPath="url(#clip0_110_16495)">
        <path
          id="Vector"
          opacity="0.2"
          d="M5.15527 20.9448C5.15527 20.3481 5.39233 19.7758 5.81428 19.3538C6.23624 18.9319 6.80854 18.6948 7.40527 18.6948H20.1553V3.69482H7.40527C6.80854 3.69482 6.23624 3.93188 5.81428 4.35383C5.39233 4.77579 5.15527 5.34809 5.15527 5.94482V20.9448Z"
          fill={color}
        />
        <path
          id="Vector_2"
          d="M5.15527 20.9448C5.15527 20.3481 5.39233 19.7758 5.81428 19.3538C6.23624 18.9319 6.80854 18.6948 7.40527 18.6948H20.1553V3.69482H7.40527C6.80854 3.69482 6.23624 3.93188 5.81428 4.35383C5.39233 4.77579 5.15527 5.34809 5.15527 5.94482V20.9448Z"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          id="Vector_3"
          d="M5.15527 20.9448V21.6948H18.6553"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_110_16495">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.655273 0.694824)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
